import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import vailcode from "@utils/errcode";
export default {
  name: "index",
  data() {
    return {
      isStep: 0
    };
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...userVuex.mapState(["userData"])
  },
  methods: {
    ...userVuex.mapMutations(["setUserData"]),
    onContinueRis() {
      this.isStep = 1;
      console.log("4444", this.isStep);
    },
    async onSkipGame() {
      let rs = await this.$http.post("/user/inapp", {});
      vailcode(rs, async () => {
        this.setUserData(rs.data);
        this.$router.push("/home");
      });
    }
  }
};